/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { functionWithCondition } from '@jira/platform__utils-feature-flagging-utils/src/utils/function-with-condition/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { JiraSpaPageContainerBootstrapper } from './JiraSpaPageContainerBootstrapper.tsx';
import { JiraSpaPageContainerOld } from './JiraSpaPageContainerOld.tsx';
import type { PageContainerProps } from './types.tsx';

export const PageContainer: (props: PageContainerProps) => JSX.Element = functionWithCondition(
	() => fg('jpx-463-spa-relay-query'),
	JiraSpaPageContainerBootstrapper,
	JiraSpaPageContainerOld,
);
